import { ItemList } from '../orm'

class YocoTrolley extends ItemList {
    getEntityKey() {
        return "customer/purchased_trolley/make_yoco_payment"
    }

    makePayment({ trolley_id, total_price, gateway_payment_ref }) {
      return this.saveNewObject({
        trolley: trolley_id,
        total_price_in_cents: total_price,
        gateway_payment_ref: gateway_payment_ref,
      })
    }
    
}

export const yocoTrolley = new YocoTrolley("yoco_trolley_default")
